//@ts-check
import ACTIONS from '../logic/actions';
/**
 * @param {import("../logic/types").EcrionFormState} state
 * @param {function} dispatch
 * @param {Array<import("./types").UpdateFieldOptions>} options
 */

var updateFields = function updateFields(state, dispatch, options) {
  if (!state || !state.fields || !dispatch) return;
  if (!options || !options.length) return;
  dispatch({
    type: ACTIONS.SET_FIELDS_PROPERTIES,
    payload: options
  });
};

export default updateFields;